(function () {
  const sources = [
    ['chandeliers', 4], ['pendant-lights', 4], ['ceiling-lights', 2],
    ['wall-lights-sconces', 4], ['table-lamps', 3], ['floor-lamps', 3]
  ];

  function normalizeCandidate(product) {
    if (!Array.isArray(product)) return product;
    const [id, url, title, category, source, group, image, price, compare, eventEnd, eventPrice, eventBase, eventLabel, discount] = product;
    return { id, url, title, category, source, group, image, price, compare, eventEnd, eventPrice, eventBase, eventLabel, discount };
  }

  function dayNumber(timestamp) {
    return Math.floor((timestamp + 28800000) / 86400000);
  }

  function selectProducts(candidates, day) {
    const result = [];
    const used = new Set();
    const valid = candidates.filter((product) => product && product.id && product.image && product.url && product.title);
    sources.forEach(([source, quota]) => {
      const pool = valid.filter((product) => product.source === source);
      const start = ((day * quota) % pool.length + pool.length) % pool.length;
      let selected = 0;
      for (let offset = 0; offset < pool.length && selected < quota; offset += 1) {
        const product = pool[(start + offset) % pool.length];
        if (used.has(product.id)) continue;
        used.add(product.id);
        result.push(product);
        selected += 1;
      }
    });
    if (result.length < 20 && valid.length) {
      const start = ((day * 20) % valid.length + valid.length) % valid.length;
      for (let offset = 0; offset < valid.length && result.length < 20; offset += 1) {
        const product = valid[(start + offset) % valid.length];
        if (used.has(product.id)) continue;
        used.add(product.id);
        result.push(product);
      }
    }
    return result;
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function link(className, product, text) {
    const node = element('a', className, text);
    node.href = product.url;
    return node;
  }

  function image(product, className, hero) {
    const node = element('img', className);
    const widths = hero ? [160, 240, 360, 480] : [360, 540, 720];
    const imageUrl = (width) => {
      const url = new URL(product.image, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.href;
    };
    node.src = imageUrl(hero ? 240 : 540);
    node.srcset = widths.map((width) => `${imageUrl(width)} ${width}w`).join(', ');
    node.sizes = hero ? '(max-width: 749px) 100px, 160px' : '(min-width: 861px) 25vw, 80vw';
    node.alt = product.title;
    node.width = hero ? 480 : 720;
    node.height = hero ? 480 : 1200;
    node.loading = 'lazy';
    node.decoding = 'async';
    return node;
  }

  function eventActive(product) {
    return Boolean(product.eventEnd && Date.parse(product.eventEnd?.trim() || '') > Date.now());
  }

  function appendPrice(container, product, tagName) {
    const base = element('span');
    base.dataset.eventBasePrice = '';
    base.append(element(tagName, '', product.price));
    if (product.compare) base.append(element('del', '', product.compare));
    if (eventActive(product)) {
      const event = element('orelvon-event-card-price', 'orelvon-event-card-price');
      event.dataset.endAt = product.eventEnd;
      event.append(element(tagName, 'price orelvon-event-card-price__amount', product.eventPrice));
      if (product.eventBase) event.append(element('s', 'compare-at-price orelvon-event-card-price__base', product.eventBase));
      event.append(element('small', 'orelvon-event-card-price__label', product.eventLabel));
      base.hidden = true;
      container.append(event);
    }
    container.append(base);
  }

  function heroCard(product, rank, label) {
    const card = element('article', 'orelvon-feature-card__slide' + (rank === 1 ? ' is-active' : ''));
    card.dataset.productSlide = '';
    card.dataset.rank = String(rank);
    card.dataset.productId = product.id;
    card.setAttribute('aria-hidden', rank === 1 ? 'false' : 'true');
    const media = link('orelvon-feature-card__image-wrap', product);
    media.append(image(product, 'orelvon-feature-card__image', true));
    const badge = eventActive(product) ? product.eventLabel : product.discount;
    if (badge) media.append(element('span', 'orelvon-feature-card__badge', badge));
    const details = element('div', 'orelvon-feature-card__details');
    const heading = element('h2');
    heading.append(link('', product, product.title));
    const price = element('div', 'orelvon-feature-card__price');
    appendPrice(price, product, 'strong');
    const cta = link('orelvon-feature-card__link', product, label + ' ');
    const arrow = element('span', '', '→');
    arrow.setAttribute('aria-hidden', 'true');
    cta.append(arrow);
    details.append(element('small', '', product.category), heading, price, cta);
    card.append(media, details);
    return card;
  }

  function trendingCard(product) {
    const card = link('orelvon-trending-product', product);
    card.dataset.trendingProduct = '';
    card.dataset.productGroup = product.group;
    card.dataset.productId = product.id;
    const media = element('span', 'orelvon-trending-product__media');
    media.append(image(product, 'orelvon-trending-product__image', false));
    const meta = element('span', 'orelvon-trending-product__meta');
    const price = element('span', 'orelvon-trending-product__price');
    appendPrice(price, product, 'b');
    if (!eventActive(product) && product.discount) price.append(element('em', '', product.discount));
    meta.append(element('small', '', product.category), element('strong', '', product.title), price);
    card.append(media, meta);
    return card;
  }

  function populate(root, selection) {
    if (!root || root.dataset.dailyReady === selection.key) return;
    const hero = root.querySelector('[data-product-slides]');
    const rail = root.querySelector('[data-trending-rail]');
    if (!hero && !rail) return;
    const fragment = document.createDocumentFragment();
    selection.products.forEach((product, index) => fragment.append(hero
      ? heroCard(product, index + 1, root.dataset.viewLight || selection.label)
      : trendingCard(product)));
    (hero || rail).replaceChildren(fragment);
    root.dataset.dailyReady = selection.key;
    root.dataset.dailyProductIds = selection.products.map((product) => product.id).join(',');
    root.dispatchEvent(new CustomEvent('orelvon:products-updated'));
  }

  let eventExpiryTimer;

  function initialize() {
    const data = document.querySelector('[data-orelvon-daily-candidates]');
    if (!data) return;
    let candidates;
    try { candidates = JSON.parse(data.textContent); } catch (_) { return; }
    if (!Array.isArray(candidates)) return;
    candidates = candidates.map(normalizeCandidate);
    const day = dayNumber(Date.now());
    const products = selectProducts(candidates, day);
    if (!products.length) return;
    const activeEnds = candidates.map((product) => Date.parse(product.eventEnd?.trim() || '')).filter((end) => Number.isFinite(end) && end > Date.now());
    const selection = { products, key: String(day) + ':' + String(activeEnds.length), label: data.dataset.viewLight };
    clearTimeout(eventExpiryTimer);
    if (activeEnds.length) eventExpiryTimer = setTimeout(initialize, Math.min(Math.min(...activeEnds) - Date.now() + 50, 86400000));
    document.querySelectorAll('[data-orelvon-hero], [data-orelvon-trending]').forEach((root) => populate(root, selection));
  }

  window.OrelvonDailyProducts = { dayNumber, selectProducts, initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) initialize(); });
})();
